import React , {Component } from "react";
import {Container , Row , Col , Button} from 'react-bootstrap';
import './Dashboard.css';

// api
import axios from 'axios';



// 傳入內部的 Context
import AppContext from "../../AppContext";

import img_1_1 from "../../../img/1_1.png";
import img_1_2 from "../../../img/1_2.png";
import img_1_3 from "../../../img/1_3.png";
import img_1_4 from "../../../img/1_4.png";

import img_2_1 from "../../../img/2_1.png";
import img_2_2 from "../../../img/2_2.png";
import img_2_3 from "../../../img/2_3.png";
import img_2_4 from "../../../img/2_4.png";

import img_3_1 from "../../../img/3_1.png";
import img_3_2 from "../../../img/3_2.png";
import img_3_3 from "../../../img/3_3.png";
import img_3_4 from "../../../img/3_4.png";

import img_4_1 from "../../../img/4_1.png";
import img_4_2 from "../../../img/4_2.png";
import img_4_3 from "../../../img/4_3.png";
import img_4_4 from "../../../img/4_4.png";

import img_5_1 from "../../../img/5_1.png";
import img_5_2 from "../../../img/5_2.png";
import img_5_3 from "../../../img/5_3.png";
import img_5_4 from "../../../img/5_4.png";

import img_6_1 from "../../../img/6_1.png";
import img_6_2 from "../../../img/6_2.png";
import img_6_3 from "../../../img/6_3.png";
import img_6_4 from "../../../img/6_4.png";



import link_btn_1 from "../../../img/link_btn_1.png";
import link_btn_2 from "../../../img/link_btn_2.png";
import link_btn_3 from "../../../img/link_btn_3.png";
import link_btn_4 from "../../../img/link_btn_4.png";

import btn_1_1 from "../../../img/btn_1_1.png";
import btn_1_2 from "../../../img/btn_1_2.png";

import btn_2_1 from "../../../img/btn_2_1.png";
import btn_2_2 from "../../../img/btn_2_2.png";

import btn_3_1 from "../../../img/btn_3_1.png";
import btn_3_2 from "../../../img/btn_3_2.png";

import btn_4_1 from "../../../img/btn_4_1.png";
import btn_4_2 from "../../../img/btn_4_2.png";


export default class Dashboard extends Component
{

    // 傳入內部的 Context
    static contextType = AppContext;

    constructor(props, context)
    {
        super(props, context);

        this.state =
            {
                language:1,
                news:"",
                Field1:"",
                Field2:"",
                Field3:"",
                Field4:"",
                Field5:"",
                Field6:"",
                Field7:"",
                Field8:"",
            };


        this.setLanguage = this.setLanguage.bind(this);
    }

    componentDidMount()
    {
        console.log("componentDidMount");
        this.getNewsData();
    }


    setLanguage(val)
    {
        this.setState({language: val });
    }


    getNewsData()
    {
        axios
        .get("https://phoneapp168.com:3098/api/front/getnews")
        .then((response)=>
        {
            console.log("API Success: "+response.data.Field1);

            this.setState({Field1: response.data.Field1 , Field2: response.data.Field2 , Field3: response.data.Field3 ,
                Field4: response.data.Field4 , Field5: response.data.Field5 , Field6: response.data.Field6 ,
                Field7: response.data.Field7 , Field8: response.data.Field8});

            // this.setState({news: <div dangerouslySetInnerHTML={{__html: response.data.data}} /> });

        })
        .catch(function (error)
        {
            // console.log("API Err: "+JSON.stringify(error));
        });
    }

    render()
    {
        return(
            <div style={{height:"100%"}}>

                <Container id="mainContainer">
                    <Row id="mainRow">
                        <Col className="contentCol" xs={12}>
                            <img src={this.state.language==1?(btn_1_2):(btn_1_1)} alt="" className="lang_1" onClick={()=>this.setLanguage(1)}/>
                            <img src={this.state.language==2?(btn_2_2):(btn_2_1)} alt="" className="lang_2" onClick={()=>this.setLanguage(2)}/>
                            <img src={this.state.language==3?(btn_3_2):(btn_3_1)} alt="" className="lang_3" onClick={()=>this.setLanguage(3)}/>
                            <img src={this.state.language==4?(btn_4_2):(btn_4_1)} alt="" className="lang_4" onClick={()=>this.setLanguage(4)}/>

                            <img src={this.state.language==1?(img_1_1): (this.state.language==2? (img_1_2) : (this.state.language==3? (img_1_3) : (img_1_4)))} alt="" className="banner_img"/>

                            <img src={this.state.language==1?(link_btn_1):(this.state.language==2?(link_btn_2):(this.state.language==3?(link_btn_3):(link_btn_4)))} alt="" className="link_btn" onClick={()=>window.location.href="https://phoneapp168.com:3098/download/CallerId.apk?openExternalBrowser=1"}/>
                        </Col>

                        <Col className="contentCol" xs={12}>
                            <img src={this.state.language==1?(img_2_1):(this.state.language==2?(img_2_2):(this.state.language==3?(img_2_3):(img_2_4)))} alt="" className="banner_img"/>
                        </Col>

                        <Col className="contentCol" xs={12}>
                            <div  className="news_board" >
                                {/*{this.state.news}*/}
                                <div className="title" >{this.state.Field1}</div>
                                {/*<div style={{fontSize:"2rem" , margin: "20px 0px" , color: "#5b5b5b"}}>內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容</div>*/}
                                <div className="content" >{this.state.Field2}</div>
                                <div className="content">{this.state.Field3}</div>
                                <div className="content">{this.state.Field4}</div>
                                <div className="content">{this.state.Field5}</div>
                                <div className="content">{this.state.Field6}</div>
                                <div className="content">{this.state.Field7}</div>
                                <div className="content">{this.state.Field8}</div>
                            </div>

                        </Col>

                        <Col className="contentCol" xs={12}>
                            <img src={this.state.language==1?(img_3_1):(this.state.language==2?(img_3_2):(this.state.language==3?(img_3_3):(img_3_4)))} alt="" className="banner_img"/>
                        </Col>

                        <Col className="contentCol" xs={12}>
                            <img src={this.state.language==1?(img_4_1):(this.state.language==2?(img_4_2):(this.state.language==3?(img_4_3):(img_4_4)))} alt="" className="banner_img"/>
                        </Col>

                        <Col className="contentCol" xs={12}>
                            <img src={this.state.language==1?(img_5_1):(this.state.language==2?(img_5_2):(this.state.language==3?(img_5_3):(img_5_4)))} alt="" className="banner_img"/>
                        </Col>

                        <Col className="contentCol" xs={12}>
                            <img src={this.state.language==1?(img_6_1):(this.state.language==2?(img_6_2):(this.state.language==3?(img_6_3):(img_6_4)))} alt="" className="banner_img"/>
                        </Col>



                    </Row>
                </Container>

                {/*<footer>*/}
                {/*    <span >為維護全體用戶權益,經查若用戶違反正常使用原則,本系統將自動停權該用戶三天或永久。</span>*/}
                {/*</footer>*/}

            </div>
        )

    }
}

